'use client'

import DocPage from './DocPage'

export default function Delivery({ vendor }: { vendor?: any }) {
  return (
    <DocPage
      vendor={vendor}
      pageKey="delivery"
      titleLead="Хүргэлтийн"
      titleAccent="нөхцөл"
      description="Захиалга хүлээн авах хугацаа, бүс нутаг, хүргэлттэй холбоотой мэдээлэл."
      htmlContent={vendor?.terms?.delivery}
      emptyMessage="Одоогоор хүргэлтийн нөхцөл нэмэгдээгүй байна."
    />
  )
}
